<template>
  <span>
    <v-row no-gutters v-for="(relation, idx) in relationsList" :key="idx">
      <the-relation
        :relation="relation"
        :dataSourceName="dataSourceName"
        :featureId="featureId"
        :hover-disabled="allHovered"
      />
    </v-row>
  </span>
</template>
<script>
import { get } from 'vuex-pathify';
import TheRelation from '@/components/TheRelation';
export default {
  name: 'RelationsList',
  components: { TheRelation },
  props: {
    featureId: {
      type: [String, Number],
      required: true,
    },
    dataSourceName: {
      type: String,
      required: true,
    },
  },
  computed: {
    relations: get('relations/relations'),
    relationsList() {
      return this.relations?.[this.dataSourceName]?.[this.featureId] || [];
    },
  },
  data: () => ({
    allHovered: false,
  }),
  methods: {
    toggleAllRelations(value) {
      this.$root.$emit('toggleFeatureHover', this.relationsList, value);
      this.allHovered = value;
    },
  },
  watch: {
    relationsList: {
      handler() {
        if (this.allHovered) this.toggleAllRelations(true);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.$root.$emit('toggleFeatureHover', null, false);
  },
};
</script>
